export const countriesNotAvailableCodes = [
  "AS", // American Samoa
  "AD", // Andorra
  "AI", // Anguilla
  "AG", // Antigua and Barbuda
  "AM", // Armenia
  "AW", // Aruba
  "AZ", // Azerbaijan
  "BY", // Belarus
  "XB", // Bonaire
  "BV", // Bouvet Island
  "BF", // Burkina Faso
  "BI", // Burundi
  "IC", // Canary Islands
  "CV", // Cape Verde
  "CF", // Central African Republic
  "TD", // Chad
  "CX", // Christmas Island
  "CC", // Cocos Islands
  "KM", // Comoros
  "CK", // Cook Islands
  "CU", // Cuba
  "XC", // Curacao
  "DJ", // Djibouti
  "DM", // Dominica
  "ER", // Eritrea
  "FK", // Falkland Islands
  "FO", // Faroe Islands
  "GI", // Gibraltar
  "GL", // Greenland
  "GD", // Grenada
  "GU", // Guam
  "GG", // Guernsey
  "GN", // Guinea
  "GW", // Guinea-Bissau
  "GY", // Guyana
  "IM", // Isle of Man
  "JE", // Jersey
  "KI", // Kiribati
  "KV", // Kosovo
  "KG", // Kyrgyzstan
  "LR", // Liberia
  "LY", // Libya
  "LI", // Liechtenstein
  "MH", // Marshall Islands
  "MR", // Mauritania
  "YT", // Mayotte
  "FM", // Micronesia
  "MD", // Moldova
  "MC", // Monaco
  "ME", // Montenegro
  "MS", // Montserrat
  "NR", // Nauru
  "XN", // Nevis
  "NC", // New Caledonia
  "NE", // Niger
  "NU", // Niue
  "NF", // Norfolk Island
  "KP", // North Korea
  "MP", // Northern Mariana Islands
  "PW", // Palau
  "PN", // Pitcairn
  "PR", // Puerto Rico
  "XS", // Somalia Hargeisa
  "RW", // Rwanda
  "XE", // Saint Eustatius
  "SH", // Saint Helena
  "KN", // Saint Kitts
  "LC", // Saint Lucia
  "XM", // Saint Martin
  "PM", // Saint Pierre and Miquelon
  "WS", // Samoa
  "SM", // San Marino
  "ST", // Sao Tome and Principe
  "SB", // Solomon Islands
  "SO", // Somalia Mogadishu
  "XY", // St. Barthelemy
  "SR", // Suriname
  "SJ", // Svalbard and Jan Mayen
  "PF", // Tahiti
  "TJ", // Tajikistan
  "TG", // Togo
  "TK", // Tokelau
  "TO", // Tonga
  "TN", // Tunisia
  "TM", // Turkmenistan
  "TC", // Turks and Caicos Islands
  "TV", // Tuvalu
  "VI", // U.S. Virgin Islands
  "UZ", // Uzbekistan
  "VU", // Vanuatu
  "VA", // Vatican
  "WF", // Wallis and Futuna
];
